export default __webpack_public_path__ + "static/logo-footer-das-ohr-with-label-59fc820f88c1c10eb89aaadc9f9c1445.png";